import { Tag } from "antd";
import React from "react";
import appConfig from "../../../../config/config.json";
import {
  CheckCircleOutlined,
  ExclamationCircleOutlined,
  MinusCircleOutlined,
} from "@ant-design/icons";
import { AiFillIeCircle } from "react-icons/ai";

const OtherRecordOfBiddersDetails = ({ data }) => {
  return (
    <div className="details_div">
      <table
        id="paymentVoucherDetails"
        className="table table-striped table-hover"
      >
        <thead>
          <tr>
            <th scope="col">Column</th>
            <th scope="col">Data</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Record Of Bidders Form No.</td>
            <td>{data.id}</td>
          </tr>
          <tr>
            <td>Rfq No.</td>
            <td>{data.rfqDetails?.rfqno}</td>
          </tr>
          <tr>
            <td>Deadline Of Submission</td>
            <td>
              {new Date(data.rfqDetails?.deadline_of_submission).toDateString()}
            </td>
          </tr>
          <tr>
            <td>Subject Of procurement</td>
            <td>{data.rfqDetails?.subject}</td>
          </tr>
          <tr>
            <td>Status</td>
            <td>
              {data.status === appConfig.status.approved && (
                <Tag icon={<CheckCircleOutlined />} color="success">
                  {data.status}
                </Tag>
              )}
              {data.status === appConfig.status.checked && (
                <Tag icon={<MinusCircleOutlined />} color="processing">
                  {data.status}
                </Tag>
              )}
              {data.status === appConfig.status.created && (
                <Tag icon={<ExclamationCircleOutlined />} color="warning">
                  Pending
                </Tag>
              )}
              {data.status === appConfig.status.pending && (
                <Tag icon={<ExclamationCircleOutlined />} color="warning">
                  Pending
                </Tag>
              )}
              {data.status === appConfig.status.rejected && (
                <Tag icon={<AiFillIeCircle />} color="error">
                  Rejected
                </Tag>
              )}
            </td>
          </tr>
          <tr>
            <td>Created By</td>
            <td>{`${data?.creator?.first_name} ${data?.creator?.other_names}`}</td>
          </tr>
          <tr>
            <td>Created At</td>
            <td>
              {`${new Date(data.created_at).toDateString()} ${new Date(
                data.created_at
              ).toLocaleTimeString()}
                                   `}
            </td>
          </tr>
          <tr>
            <td>Last Updated By</td>
            <td>
              {data.updator &&
                `${data?.updator?.first_name} ${data?.updator?.other_names}`}
            </td>
          </tr>
          <tr>
            <td>Last Updated At</td>
            <td>
              {data.updated_at &&
                `${new Date(data.updated_at).toDateString()} ${new Date(
                  data.updated_at
                ).toLocaleTimeString()}`}
            </td>
          </tr>
          <tr>
            <td>Checked By</td>
            <td>
              {data.checker &&
                `${data?.checker?.first_name} ${data?.checker?.other_names}`}
            </td>
          </tr>
          <tr>
            <td>Checked At</td>
            <td>
              {data.checked_at &&
                `${new Date(data.checked_at).toDateString()} ${new Date(
                  data.checked_at
                ).toLocaleTimeString()}
                                   `}
            </td>
          </tr>
          <tr>
            <td>Approved By</td>
            <td>
              {data.approver &&
                `${data?.approver?.first_name} ${data?.approver?.other_names}`}
            </td>
          </tr>
          <tr>
            <td>Approved At</td>
            <td>
              {data.approved_at &&
                `${new Date(data.approved_at).toDateString()} ${new Date(
                  data.approved_at
                ).toLocaleTimeString()}`}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default OtherRecordOfBiddersDetails;
